import {SvgIcon } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoIcon } from '../icons/logo.svg';




export default function DisplayLogo({...props}) {
    return(
        
        <IconButton
            disableRipple
            component={Link}
            to="/"
            sx={{ 
                p: 0,
            }}
            aria-label="home"
            >
                <SvgIcon

                    component={LogoIcon} sx={{...props}}
                    // inheritViewBox


                    />    
            </IconButton>
    )
};